export default __webpack_public_path__ + "static/BayswaterCarousel_0003-55ea2b33f6ad12d61e71be491aca52b4.jpg";